import styled from 'styled-components';
import { baseVariables, toRem } from '@marriott/mi-ui-library';
export const StyledCobrandCarousel = styled.div`
  .glide {
    &__slide--active {
      justify-content: center;
    }
    &__slides {
      li {
        margin: 0;
      }
    }
  }
  .container > div {
    display: flex;
    flex-grow: 1;
  }
  .featured-card-wrapper {
    @media ${baseVariables.mediaQuery.lg} {
      width: 100%;
      max-width: ${toRem(946)};
    }
  }
`;
